(() => {
  'use strict';

  const STORAGE_KEY = 'away-theme-mode';
  const ATTRIBUTE = 'data-away-theme';
  const root = document.documentElement;

  function getStoredTheme() {
    try {
      const value = localStorage.getItem(STORAGE_KEY);

      return value === 'dark' || value === 'light'
        ? value
        : null;
    } catch (error) {
      return null;
    }
  }

  function getSystemTheme() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  }

  function getCurrentTheme() {
    return root.getAttribute(ATTRIBUTE)
      || getStoredTheme()
      || getSystemTheme();
  }

  function updateControls(theme) {
    const isDark = theme === 'dark';

    document.querySelectorAll('[data-away-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute(
        'aria-label',
        isDark ? 'Gündüz moduna geç' : 'Gece moduna geç'
      );

      button.setAttribute(
        'title',
        isDark ? 'Gündüz moduna geç' : 'Gece moduna geç'
      );
    });

    document.querySelectorAll('[data-away-theme-label]').forEach((label) => {
      label.textContent = isDark ? 'Gece modu' : 'Gündüz modu';
    });
  }

  function applyTheme(theme, options = {}) {
    const normalizedTheme = theme === 'dark' ? 'dark' : 'light';

    root.setAttribute(ATTRIBUTE, normalizedTheme);
    root.style.colorScheme = normalizedTheme;

    if (options.animate) {
      root.classList.add('away-theme-animating');

      window.setTimeout(() => {
        root.classList.remove('away-theme-animating');
      }, 300);
    }

    if (options.persist) {
      try {
        localStorage.setItem(STORAGE_KEY, normalizedTheme);
      } catch (error) {
        // Tarayıcı depolaması kapalıysa tema yine çalışır.
      }
    }

    updateControls(normalizedTheme);

    window.dispatchEvent(
      new CustomEvent('away:themechange', {
        detail: {
          theme: normalizedTheme
        }
      })
    );
  }

  function toggleTheme() {
    const nextTheme = getCurrentTheme() === 'dark'
      ? 'light'
      : 'dark';

    applyTheme(nextTheme, {
      persist: true,
      animate: true
    });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-away-theme-toggle]');

    if (!toggle) return;

    event.preventDefault();
    toggleTheme();
  });

  document.addEventListener('DOMContentLoaded', () => {
    applyTheme(getCurrentTheme());
  });

  document.addEventListener('shopify:section:load', () => {
    updateControls(getCurrentTheme());
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY) return;

    applyTheme(getStoredTheme() || getSystemTheme());
  });

  const systemPreference = window.matchMedia('(prefers-color-scheme: dark)');

  systemPreference.addEventListener?.('change', (event) => {
    if (getStoredTheme()) return;

    applyTheme(event.matches ? 'dark' : 'light');
  });
})();